const styles = {
  subTitle: {
    margin: '16px 0',

    '& > p': {
      fontSize: '14px',
    },
  },
}

export default styles
